<template>
  <div class="rateArea" v-if="this.userInfo != null">
    <div class="rateView" id="rate">
      <h3>课程评分</h3>
      <div class="rateTotal">
        <span class="rateNum">{{ rateStarTotal }}</span>
        <div>
          <a-rate :value="rateStarTotal" disabled allow-half/>
          <p class="reviewNum">共{{ pagTotal }}条评论</p>
        </div>
      </div>
    </div>
    <div class="publishRate" v-if="this.isRate == 0">
      <h3>您对本次课程的评价</h3>
      <a-form ref="rateFormRef" layout="vertical" :model="rateForm" :rules="rateFormRules">
        <a-form-item name="star" label="总评" required>
          <span>
            <a-rate v-model:value="rateForm.star" :tooltips="desc" allow-half/>
            <span class="ant-rate-text">{{ desc[rateForm.star - 1] }}</span>
          </span>
        </a-form-item>
        <a-form-item name="remark" label="评价内容">
          <a-textarea
            v-model:value="rateForm.remark"
            defaultValue="可以从直播课程内容的难易程度，授课方式的角度来评价课程，或者分享课程给您带来了什么收获和启发......"
            :rows="6"
          />
        </a-form-item>
        <div style="text-align: right">
          <a-button type="primary" size="large" @click="publishRate">发表评论</a-button>
        </div>
      </a-form>
    </div>
    <div class="rate_list">
      <!-- 我自己的评价 -->
      <div class="rate_item" v-if="myRateData != ''">
        <a-avatar :src="myRateData.head_img" :size="44">
          <template #icon><UserOutlined /></template>
        </a-avatar>
        <div class="rate_info">
          <div class="rate_head">
            <div class="rate_star">
              <span class="name">{{ myRateData.name }}</span>
              <a-rate :value="myRateData.star" disabled />
              <span class="myRateTip">（我的评价）</span>
            </div>
            <div class="rate_time">{{ myRateData.add_time }}</div>
          </div>
          <div class="rate_body">
            {{ myRateData.content }}
          </div>
        </div>
        <div class="myRateOperate">
          <div class="operateBtn">
            <!-- <i class="iconfont icon-zwxiugai2" @click="rateEditBtn(myRateData.id)"></i> -->
            <a-popconfirm
              title="确定删除该评论吗？"
              ok-text="确定"
              cancel-text="取消"
              @confirm.stop="rateDeleteBtn(myRateData.id)"
              @cancel="deleteCancel"
            >
              <i class="iconfont icon-zwshanchu"></i>
            </a-popconfirm>
            <span class="like" :class="myRateData.type == 1 ? 'isLike' : ''" @click="likeBtn(myRateData.id)">
              <i class="iconfont icon-zwdianzan" :class="myRateData.type == 1 ? 'isLike' : ''"></i>
              {{ myRateData.like }}
            </span>
          </div>
        </div>
      </div>

      <div class="rate_item" v-for="rate in rateData" :key="rate.id">
        <a-avatar :src="rate.head_img" :size="44">
          <template #icon><UserOutlined /></template>
        </a-avatar>
        <div class="rate_info">
          <div class="rate_head">
            <div class="rate_star">
              <span class="name">{{ rate.name }}</span>
              <a-rate :value="rate.star" disabled />
            </div>
            <div class="rate_time">{{ rate.add_time }}</div>
          </div>
          <div class="rate_body">
            {{ rate.content }}
          </div>
        </div>
        <div class="like" :class="rate.type == 1 ? 'isLike' : ''" @click="likeBtn(rate.id)">
          <i class="iconfont icon-zwdianzan"></i>
          {{ rate.like }}
        </div>
      </div>
    </div>
    <!-- 分页区域 -->
    <div class="paging">
      <a-divider style="margin: 0 0 16px; background-color: #ebebeb" />
      <a-pagination
        v-model:current="pagCurrent"
        v-model:pageSize="pageSize"
        :total="pagTotal"
        @change="pagChange"
        :show-size-changer="false"
        :show-total="(total) => `共 ${total} 条`"
        show-quick-jumper
        show-less-items
      />
    </div>
  </div>
  <div class="empty" v-else>
    <LockOutlined style="font-size: 30px; color: rgba(0, 0, 0, 0.45)" />
    <p>未登录时无法查看评论</p>
    <a-button type="primary" @click="rateLogin">立即登录</a-button>
  </div>
</template>

<script>
import { UserOutlined, LockOutlined } from '@ant-design/icons-vue'
export default {
  name: 'Evaluate',
  components: { UserOutlined, LockOutlined },
  props: ['rateId', 'rateType'],
  data() {
    return {
      userInfo: null,
      rateForm: {
        star: 0,
        remark: '',
      },
      rateFormRules: {
        star: [{ pattern: /[^0]+/, message: '请评分', trigger: 'change' }],
        remark: [
          { required: true, message: '请输入评价内容', trigger: 'blur' },
          {
            min: 5,
            message: '至少输入5个字',
            trigger: 'blur',
          },
        ],
      },
      desc: ['课程内容难', '课程一般般', '课程还不错', '课程收获多', '课程非常棒'],
      myRateData: {},
      rateData: [],
      rateStarTotal: 0,
      isRate: 0,
      pagCurrent: 1,
      pageSize: 6,
      pagTotal: 0,
    }
  },
  mounted() {
    this.userInfo = JSON.parse(window.localStorage.getItem('userInfo'))
    this.getRateData()
  },
  methods: {
    async getRateData() {
      const { data: res } = await this.$http.post('index/get_comment', {
        type: this.rateType,
        id: this.rateId,
        page: this.pagCurrent,
        pagesize: this.pageSize,
      })
      // console.log(res)
      this.myRateData = res.my_comment
      this.rateData = res.comment
      this.rateStarTotal = res.data.star
      this.isRate = res.data.c_type
      this.pagTotal = res.count
    },
    rateLogin() {
      this.$bus.emit('openLogin')
    },
    async publishRate() {
      if (this.isRate == 1) {
        return this.$message.info('您已评价，感谢！')
      }
      if (this.userInfo == null) {
        return this.$bus.emit('openLogin')
      }
      try {
        const values = await this.$refs.rateFormRef.validateFields()
        var star = this.rateForm.star
        var content = this.rateForm.remark
        this.$refs.rateFormRef.resetFields()
        const { data: res } = await this.$http.post('index/comment', {
          type: this.rateType,
          id: this.rateId,
          star: star,
          content: content,
          time: '',
        })
        if (res.code == 100) {
          return this.$message.warning(`${res.msg}`)
        }
        if (res.code == 300) {
          this.$message.warning('登录已失效')
          window.localStorage.clear()
          location.reload()
        }
        if (res.code == 200) {
          if (this.rateType == 1) {
            this.$bus.emit('getLiveRataTotal', { type: '0' })
          } else if (this.rateType == 2) {
            this.$bus.emit('getCourseRataTotal', { type: '0' })
          }
          this.getRateData()
        }
      } catch (errorInfo) {
        // console.log('Failed:', errorInfo.outOfDate)
      }
    },
    async rateEditBtn(id) {
      // const { data: res } = await this.$http.post('index/like', { id: id })
      // console.log(res)
      // if (res.code == 200) {
      //   this.getRateData()
      // }
    },
    async rateDeleteBtn(id) {
      const { data: res } = await this.$http.post('user/del_comment', { id: id })
      if (res.code == 100) {
        return this.$message.warning(`${res.msg}`)
      }
      if (res.code == 300) {
        this.$message.warning('登录已失效')
        window.localStorage.clear()
        location.reload()
      }
      if (res.code == 200) {
        this.$message.success(`${res.msg}`)
        if (this.rateType == 1) {
          this.$bus.emit('getLiveRataTotal', { type: '1' })
        } else if (this.rateType == 2) {
          this.$bus.emit('getCourseRataTotal', { type: '1' })
        }
        this.getRateData()
      }
    },
    deleteCancel() {
      this.$message.info('取消删除')
    },
    async likeBtn(id) {
      const { data: res } = await this.$http.post('index/like', { id: id })
      if (res.code == 100) {
        return this.$message.warning(`${res.msg}`)
      }
      if (res.code == 300) {
        this.$message.warning('登录已失效')
        window.localStorage.clear()
        location.reload()
      }
      if (res.code == 200) {
        this.getRateData()
      }
    },
    pagChange() {
      this.getRateData()
    },
  },
}
</script>

<style scoped lang="less">
.rateView,
.publishRate {
  width: 100%;
  height: auto;
  background-color: #fafafa;
  padding: 40px 20px;
  margin-bottom: 40px;
  h3 {
    font-size: 24px;
  }
  .rateTotal {
    display: flex;
    align-items: center;
  }
  .ant-rate {
    font-size: 30px;
  }
  .rateNum {
    font-size: 52px;
    font-weight: bold;
    color: #ff7a3e;
    margin-right: 16px;
  }
  .reviewNum {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.25);
  }
}
.rate_item {
  width: 100%;
  display: flex;
  justify-content: space-around;
  border-bottom: 1px solid #ebebeb;
  margin-bottom: 40px;
  padding-bottom: 40px;
  .rate_info {
    width: 600px;
    .rate_head {
      margin-bottom: 8px;
      .rate_star {
        .name {
          font-size: 14px;
          color: rgba(0, 0, 0, 0.85);
          margin-right: 8px;
        }
        .myRateTip {
          color: rgba(0, 0, 0, 0.45);
        }
      }
      .rate_time {
        font-size: 12px;
        color: rgba(0, 0, 0, 0.45);
      }
    }
    .rate_body {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.85);
      // white-space: nowrap;
      // text-overflow: ellipsis;
      // overflow: hidden;
    }
  }
  .myRateOperate {
    position: relative;
    display: flex;
    width: 46px;
    .operateBtn {
      position: absolute;
      top: 0;
      right: 0;
      min-width: 120px;
      text-align: right;
      .iconfont {
        font-size: 12px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 20px;
        margin-left: 16px;
        cursor: pointer;
      }
    }
  }
  .like {
    width: 46px;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.45);
    text-align: right;
    cursor: pointer;
    .iconfont {
      font-size: 20px;
    }
  }
  .isLike {
    color: #3A84FF !important;
  }
}
.rate_item:last-child {
  border-bottom: none;
}
.paging {
  position: absolute;
  left: 20px;
  bottom: 40px;
  width: 753px;
  text-align: center;
}
.empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 120px;
  .anticon-lock {
    margin-bottom: 16px;
  }
  p {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.45);
    margin-bottom: 16px;
  }
}
</style>
